import Sidebar from '../Sidebar';
import Settings from './Settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

function Pocket(props: any) {
    return <Sidebar>
        <Settings />
        <div className="sidebar__header pocket">{props.section}</div>
        <div className="sidebar__content">
            <span id='gettoknow'>{props.description}</span>
            <div className="pocket_list">
                <span id='noteSec'>
                    {props.secondary.map((text: string, ind: number) => {
                        return (
                            <div key={ind} style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                <FontAwesomeIcon icon={faStar} />
                                <li>{text}</li>
                            </div>
                        );
                    })}
                </span>
            </div>
        </div>
        {(props.show)
            ? <div className='sidebar__controls'>
                <div className="sidebar__controls__header">Press 'x' to enter!</div>
                <div className="sidebar__controls__content">
                    <div className="sidebar__controls__content__col pocket">
                        <div id="ex" className='icons'></div>
                    </div>
                </div>
            </div>
            : <div className='sidebar__controls'>
                <div className="sidebar__controls__header"></div>
            </div>
        }

    </Sidebar>;
}

export default Pocket;
